module.exports = __webpack_public_path__ + "media/images/webpage/hotels/7167/plan3-2-fe116febe60e02cd79cac704e73ab12e.webp";